export default "__VITE_ASSET__CZJYUgOr__"